/**
 * Checks if some of the values in the first array are present in the second array.
 *
 * @param {any} value The value or array of values to check.
 * @param {ReadonlyArray<any>} arr The array to check against.
 * @returns {boolean} Whether some of the values are in the array.
 */
export const someIn = (value, arr) => {
    if (Array.isArray(value)) {
        return value ? value.some(v => arr.includes(v)) : false;
    }
    return arr.includes(value);
};
